var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.tableHeaders,"items":_vm.workScheduleDays,"disable-sort":"","disable-pagination":"","hide-default-footer":"","sort-by":"day"},scopedSlots:_vm._u([{key:"item.day",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(item.day)+"\n  ")]}},{key:"item.category",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.getReadableCategory(item.category))+"\n  ")]}},{key:"item.startTime",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.getWorkingStartTime(item.segments))+"\n  ")]}},{key:"item.endTime",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.getWorkingEndTime(item.segments))+"\n  ")]}},{key:"item.breaks",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.getBreaksSummary(item.segments))+"\n  ")]}},{key:"item.workingDuration",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.getWorkingDuration(item.segments))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }